module.exports = __webpack_public_path__ + "img/icono_hijo.0724d5d9.svg";